export enum BANK_ACCOUNT_ACTIONS {
  SET_BANK_LIST = 'BANK_ACCOUNT_ACTIONS.SET_BANK_LIST',
  SET_BANK_ACCOUNT_LIST = 'BANK_ACCOUNT_ACTIONS.SET_BANK_ACCOUNT_LIST',
}
